import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_MY_UQ || "uq.my.new-styling-book",
  ugcClientId: process.env.REACT_APP_UGC_CLIENT_ID_MY_UQ || "uqmy-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_MY_UQ || 27431,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_MY_UQ || 27432,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_MY_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_MY_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_MY_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_MY_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.EN],
  countryRegion: "Asia/Kuala_Lumpur",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "MYT",
      offset: {
        MYT: +8,
        "GMT+7:30": +8
      }
    }
  },
  timeZoneParentCategory: {
    "GMT+7:30": "MYT"
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>"
  },
  shortDateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>"
  },
  requireDecimal: true,
  memberPricingEnabled: true
};

export default _countryEnv;
